import script from "./DNSList.vue?vue&type=script&setup=true&lang=js"
export * from "./DNSList.vue?vue&type=script&setup=true&lang=js"

import "./DNSList.vue?vue&type=style&index=0&id=0a4aa5f2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4aa5f2"]])

export default __exports__